module.exports = __webpack_public_path__ + "img/capa-bloco.955f8917.webp";